import Button from "../Button/Button";
import { jsx as _jsx, Fragment as _Fragment } from "preact/compat/jsx-runtime";
export default function Page(_ref) {
  let {
    href,
    index,
    isActive,
    onPageChange
  } = _ref;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isActive ? /*#__PURE__*/_jsx("span", {
      className: "ds-c-button ds-c-button--ghost ds-c-pagination__current-page",
      "aria-current": "page",
      children: index
    }) : /*#__PURE__*/_jsx(Button, {
      variation: "ghost",
      href: href,
      onClick: onPageChange,
      "aria-label": `page ${index}`,
      children: index
    })
  });
}